import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FormClose = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FormClose' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M7,7 L17,17 M7,17 L17,7' />
  </StyledIcon>
);
